import React from "react";

import { auth } from "../firebase";
import "../css/Signout.css";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

function Signout() {
  const signOut = (event) => {
    event.preventDefault();
    auth.signOut();
  };

  return (
    <p className="signout" onClick={signOut}>
      <ExitToAppIcon /> Logout
    </p>
  );
}

export default Signout;
